(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer-slideshow"] && !Shopify.designMode) return;
  try {
    if (!window.customElements.get('cart-drawer-slideshow')) {
    class CartDrawerSlideshow extends HTMLElement {
      constructor() {
        super();
        this._currentIndex = 0;
        this._timer = null;
        this._isPaused = false;
        this._onScroll = this._onScroll.bind(this);
        this._onMouseEnter = this._onMouseEnter.bind(this);
        this._onMouseLeave = this._onMouseLeave.bind(this);
        this._onBlockSelect = this._onBlockSelect.bind(this);
        this._onBlockDeselect = this._onBlockDeselect.bind(this);
      }

      connectedCallback() {
        this._track = this.querySelector('.cart-drawer-slideshow__track');
        this._slides = Array.from(this.querySelectorAll('.cart-drawer-slideshow__slide'));
        this._dots = Array.from(this.querySelectorAll('.cart-drawer-slideshow__dot'));

        if (!this._track || this._slides.length === 0) return;

        this._track.addEventListener('scroll', this._onScroll, { passive: true });
        this.addEventListener('mouseenter', this._onMouseEnter);
        this.addEventListener('mouseleave', this._onMouseLeave);
        this.addEventListener('touchstart', this._onMouseEnter, { passive: true });
        this.addEventListener('touchend', this._onMouseLeave, { passive: true });

        // Mouse drag support for desktop
        let isDown = false;
        let startX = 0;
        let scrollStart = 0;
        let hasMoved = false;

        this._track.addEventListener('mousedown', (e) => {
          isDown = true;
          hasMoved = false;
          startX = e.pageX - this._track.offsetLeft;
          scrollStart = this._track.scrollLeft;
          this._track.classList.add('is-dragging');
          this._onMouseEnter();
        });

        window.addEventListener('mousemove', (e) => {
          if (!isDown) return;
          const x = e.pageX - this._track.offsetLeft;
          const distance = x - startX;
          if (Math.abs(distance) > 4) {
            hasMoved = true;
          }
          this._track.scrollLeft = scrollStart - distance;
        });

        window.addEventListener('mouseup', () => {
          if (!isDown) return;
          isDown = false;
          this._track.classList.remove('is-dragging');
          const slideWidth = this._slides[0].offsetWidth || 1;
          const nearestIndex = Math.round(this._track.scrollLeft / slideWidth);
          this.select(Math.max(0, Math.min(nearestIndex, this._slides.length - 1)));
          this._onMouseLeave();
        });

        this._track.addEventListener('click', (e) => {
          if (hasMoved) {
            e.preventDefault();
            e.stopPropagation();
          }
        }, true);

        this._dots.forEach((dot, index) => {
          dot.addEventListener('click', (e) => {
            e.stopPropagation();
            this.select(index);
          });
        });

        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.previous();
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.next();
          }
        });

        document.addEventListener('shopify:block:select', this._onBlockSelect);
        document.addEventListener('shopify:block:deselect', this._onBlockDeselect);

        this._startAutoplay();
      }

      disconnectedCallback() {
        this._stopAutoplay();
        if (this._track) {
          this._track.removeEventListener('scroll', this._onScroll);
        }
        this.removeEventListener('mouseenter', this._onMouseEnter);
        this.removeEventListener('mouseleave', this._onMouseLeave);
        document.removeEventListener('shopify:block:select', this._onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this._onBlockDeselect);
      }

      _onMouseEnter() {
        this._isPaused = true;
        this._stopAutoplay();
      }

      _onMouseLeave() {
        this._isPaused = false;
        this._startAutoplay();
      }

      _startAutoplay() {
        this._stopAutoplay();
        const speed = parseFloat(this.getAttribute('autoplay'));
        if (!speed || isNaN(speed) || this._slides.length <= 1) return;

        this._timer = setInterval(() => {
          if (!this._isPaused && document.visibilityState === 'visible') {
            this.next();
          }
        }, speed * 1000);
      }

      _stopAutoplay() {
        if (this._timer) {
          clearInterval(this._timer);
          this._timer = null;
        }
      }

      _onScroll() {
        if (this._scrollTimeout) cancelAnimationFrame(this._scrollTimeout);
        this._scrollTimeout = requestAnimationFrame(() => {
          const scrollLeft = this._track.scrollLeft;
          const slideWidth = this._slides[0].offsetWidth || 1;
          const newIndex = Math.round(scrollLeft / slideWidth);
          if (newIndex !== this._currentIndex && newIndex >= 0 && newIndex < this._slides.length) {
            this._currentIndex = newIndex;
            this._updateUi();
          }
        });
      }

      _updateUi() {
        this._slides.forEach((slide, idx) => {
          slide.classList.toggle('is-active', idx === this._currentIndex);
        });
        this._dots.forEach((dot, idx) => {
          dot.classList.toggle('is-active', idx === this._currentIndex);
          dot.setAttribute('aria-selected', idx === this._currentIndex ? 'true' : 'false');
        });
      }

      select(index) {
        if (index < 0 || index >= this._slides.length) return;
        this._currentIndex = index;
        const targetSlide = this._slides[index];
        if (targetSlide) {
          this._track.scrollTo({
            left: targetSlide.offsetLeft,
            behavior: 'smooth'
          });
        }
        this._updateUi();
      }

      next() {
        const nextIndex = (this._currentIndex + 1) % this._slides.length;
        this.select(nextIndex);
      }

      previous() {
        const prevIndex = (this._currentIndex - 1 + this._slides.length) % this._slides.length;
        this.select(prevIndex);
      }

      _onBlockSelect(event) {
        if (!event.target) return;
        const blockId = event.detail?.blockId;
        const slideIndex = this._slides.findIndex((slide) => {
          return slide.getAttribute('data-block-id') === blockId || slide.id.includes(blockId);
        });

        if (slideIndex !== -1) {
          this.select(slideIndex);
          this._isPaused = true;
          this._stopAutoplay();
        }
      }

      _onBlockDeselect() {
        this._isPaused = false;
        this._startAutoplay();
      }
    }

    window.customElements.define('cart-drawer-slideshow', CartDrawerSlideshow);
  }
  } catch(e) { console.error(e); }
})();

})();
